import { useTranslation } from "react-i18next";

export interface GroupLabelProps {
  groupColor?: [number, number, number];
}

export const GroupLabel = ({ groupColor }: GroupLabelProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-1">
      {groupColor && (
        <span
          className="inline-block w-3 h-3 rounded-full shrink-0"
          style={{
            backgroundColor: `rgb(${groupColor[0]},${groupColor[1]},${groupColor[2]})`,
          }}
        />
      )}
      <span className="text-sm text-gray-700 font-medium">
        {t("smartSurveyor.groupInspector.groupLabel")}
      </span>
    </div>
  );
};
